import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../core/form/TextInput';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import FetchSelect from '../../../core/form/FetchSelect';
import get from 'lodash/get';
import Button from '../../../core/form/Button';

const VocabularyListFilter = (props) => (
  <Row>
    <Column size={8}>
      <TextInput
        label="Search vocabularies"
        placeholder="Start type to filter the vocabularies"
        value={get(props.values, 'criteria')}
        onChange={(value) => props.onChange('criteria', value)}
      />
    </Column>
    <Column size={2}>
      <FetchSelect
        showSearch
        apiVersion="v3"
        url="academic-plans"
        label="Academic plan"
        isPaginated={true}
        value={get(props.values, 'academicPlan')}
        onChange={(value) => props.onChange('academicPlan', value)}
        resultTransformer={{
          text: 'name',
          value: 'id',
        }}
      />
    </Column>
    <Column size={1}>
      <div style={{ height: 42 }} />
      <Button label="Search" icon="search" onClick={props.onSearch} />
    </Column>
  </Row>
);

VocabularyListFilter.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

export default VocabularyListFilter;
